import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=beb0100c&scoped=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./GeneralSettings.vue?vue&type=style&index=0&id=beb0100c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "beb0100c",
  null
  ,true
)

export default component.exports